import { useEffect } from "react";
import PDFObject from "pdfobject";

export const PDFViewer = ({
  id,
  pdf,
  viewerHeight = "75dvh",
  style,
  ...rest
}) => {
  useEffect(() => {
    const reader = new FileReader();
    reader.readAsDataURL(pdf);
    reader.onloadend = () => {
      PDFObject.embed(reader.result, `#${id}`);
    };
  }, [pdf]);
  return (
    <div
      id={id}
      style={{
        height: viewerHeight,
        width: "100%",
        borderRadius: ".5rem",
        overflow: "hidden",
        ...style,
      }}
      {...rest}
    ></div>
  );
};
